import { Chip } from '@pocketlaw/tetris';
import { getFeedbackChipAppearance, getFeedbackIcon, getFeedbackLabel, } from 'app/domains/review/utils';
export function LegendItem(props) {
    const { type, currentAmount } = props;
    return (<Chip appearance={getFeedbackChipAppearance(type)} icon={getFeedbackIcon(type)} label={getFeedbackLabel(type)} secondary={currentAmount}/>);
}
